import { httpwmsapi } from 'src/services';
import queryString from 'query-string';

// Action Types
export const Types = {
  ORDERS_LOADING: 'order/loading',
  ORDERS_SET_DATA: 'orders/set/data',
  ORDERS_SET_PAGING: 'orders/set/paging',
  ORDERS_SET_FILTER: 'orders/set/filter',
  ORDERS_SET_FILTER_CHIP: 'orders/set/filter_chip',

  ORDER_DETAILS_SET_DATA: 'orders/details/set/data',
  ORDER_DETAILS_SET_METADATA: 'orders/details/set/metadata',
  ORDER_DETAILS_SET_PAGING: 'orders/details/set/paging',

  ORDER_OBSERVATION_SET_DATA: 'orders/observation/set/data',
};

// Reducer
const initialState = {
  loading: false,
  order: {},
  orders: [],
  orders_paging: { limit: 25, offset: 0, total: 0 },
  orders_filters_chip: [],
  orders_filters: [],
  order_details: [],
  order_details_metadata: { marketplaceAccounts: [], orderTypes: [], orderStatuses: [], deliveryTypes: [] },
  order_details_paging: { limit: 25, offset: 0, total: 0 },
  order_details_form: {
    orderType: 0,
    shippingMethod: 0,
    marketplaceAccount: 0,
    status: 0,
    products: [],
  },
  order_observation: null,
};

// Action Creators
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.ORDERS_LOADING:
      return { ...state, loading: action.payload };
    case Types.ORDERS_SET_DATA:
      return { ...state, orders: action.payload };
    case Types.ORDERS_SET_PAGING:
      return { ...state, orders_paging: action.payload };
    case Types.ORDERS_SET_FILTER:
      return { ...state, orders_filters: action.payload };
    case Types.ORDERS_SET_FILTER_CHIP:
      return { ...state, orders_filters_chip: action.payload };

    case Types.ORDER_DETAILS_SET_DATA:
      return { ...state, order_details: action.payload };
    case Types.ORDER_DETAILS_SET_METADATA:
      return { ...state, order_details_metadata: action.payload };
    case Types.ORDER_DETAILS_SET_PAGING:
      return { ...state, order_details_paging: action.payload };

    case Types.ORDER_OBSERVATION_SET_DATA:
      return { ...state, order_observation: action.payload };
    default:
      return state;
  }
}

export const Creators = {
  ordersLoading: (value) => ({ type: Types.ORDERS_LOADING, payload: value }),
  ordersSetData: (orders) => ({ type: Types.ORDERS_SET_DATA, payload: orders }),
  ordersSetPaging: (orders_paging) => ({ type: Types.ORDERS_SET_PAGING, payload: orders_paging }),
  ordersSetFilters: (orders_filters) => ({ type: Types.ORDERS_SET_FILTER, payload: orders_filters }),
  ordersSetFiltersChip: (orders_filters_chip) => ({ type: Types.ORDERS_SET_FILTER_CHIP, payload: orders_filters_chip }),
  orderDetailsSetData: (value) => ({
    type: Types.ORDER_DETAILS_SET_DATA,
    payload: value,
  }),
  orderDetailsSetMetadata: (metadata) => ({
    type: Types.ORDER_DETAILS_SET_METADATA,
    payload: metadata,
  }),
  orderDetailsSetPaging: (paging) => ({
    type: Types.ORDER_DETAILS_SET_PAGING,
    payload: paging,
  }),
  orderObservationSetData: (value) => ({
    type: Types.ORDER_OBSERVATION_SET_DATA,
    payload: value,
  }),
  getOrders: (filters = {}) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'none', encode: false });
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/orders/search?${qry}`, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getOrderDetails: ({ orderId, limit, offset }) => {
    const qry = queryString.stringify(
      {
        limit,
        offset,
      },
      { arrayFormat: 'none', encode: false }
    );
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/orders/${orderId}/items?${qry}`, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  syncOrderInvoice: (orderId) => {
    if (!orderId) {
      return Promise.reject(new Error('Número do pedido não informado.'));
    }

    return new Promise((resolve, reject) => {
      httpwmsapi
        .patch(`/v1/orders/invoice/sync`, { orderId: Number(orderId) }, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  syncOrder: (marketplaceOrderId) => {
    if (!marketplaceOrderId) {
      return Promise.reject(new Error('ID do pedido no marketplace não informado.'));
    }
    return new Promise((resolve, reject) => {
      httpwmsapi
        .patch(`/v1/orders/erp/import`, { marketplaceOrderId }, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getOrderMetadata: () => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/orders/metadata`, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getOrderType: (orderTypeId) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/orders/type/${orderTypeId}`, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getOrderCurrentEditingUser: (orderId) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/orders/${orderId}/lock`, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  setOrderCurrentEditingUser: (orderId, userName) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .patch(`/v1/orders/${orderId}/lock`, { userName }, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  updateOrder: (orderId, orderData) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .patch(`/v1/orders/${orderId}`, orderData, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getOrderObservations: (orderId) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/orders/${orderId}/observation`, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  createOrderObservations: (orderId, observation) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`/v1/orders/${orderId}/observation`, { observation }, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  createOrder: (orderData) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`/v1/orders`, orderData, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
};
